import { ExtractedEntities } from "../types";
import { buildIncidentScript } from "../shared/script_builder";

export function render(entities: ExtractedEntities): string {
  return buildIncidentScript(entities);
}
